module.exports = __webpack_public_path__ + "static/media/akash-manohar.0f2bcc03.png";